"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import MF from "mouse-follower-cube";
import gsap from "gsap";

export let cursor;

function MouseFollower() {
  const pathname = usePathname();

  useEffect(() => {
    const mobileView = window.matchMedia("(max-width: 700px)").matches;
    if (mobileView) return;

    MF.registerGSAP(gsap);
    cursor = new MF({
      container: ".mf-container",
      iconSvgSrc: "/svgs/arrow-up-right.svg",
      iconSvgClassName: "arrow-up-right",
      iconSvgNamePrefix: "-",
    });
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      const mobileView = window.matchMedia("(max-width: 700px)").matches;
      if (mobileView) return;

      const cursorEl = cursor.el;
      if (cursorEl && cursorEl.classList.contains("-text", "-pointer")) {
        cursorEl.classList.remove("-text", "-pointer");
      }
    }, 10);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
}

export default MouseFollower;
